import React, { createContext } from 'react';
import { useSocket } from '../hooks/useSocket';
import json from '../../package.json';

export const SocketContext = createContext();

export const SocketProvider = (props) => {

    const { children } = props;
    const { socket } = useSocket(json?.proxy);

    return (
        <SocketContext.Provider value={{ socket }} >
            { children }
        </SocketContext.Provider>
    )
}